import React from "react";
import { List, Popover } from "antd5";

import css from "./MultipleEntityLinks.module.scss";

export default function MultipleEntityLinks({
  title,
  links,
}: {
  title: string;
  links: JSX.Element[];
}): JSX.Element | null {
  if (links.length >= 2) {
    return (
      <>
        {links[0]}{" "}
        <Popover
          trigger="hover"
          overlayClassName={css.cellPopover}
          title={<b>{title}</b>}
          placement="left"
          content={
            <List className={css.cellPopoverList}>
              {links.slice(1).map((s, index) => (
                <List.Item key={index}>{s}</List.Item>
              ))}
            </List>
          }
        >
          <span className={css.popoverTrigger}>+ {links.length - 1} more</span>
        </Popover>
      </>
    );
  } else if (links.length === 1) {
    return links[0];
  } else {
    return null;
  }
}
